import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'add-checklist',
  templateUrl: './add-checklist.component.html',
  styleUrls: ['./add-checklist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddChecklistComponent implements OnInit {
  checklistName = 'Untitled Checklist';

  constructor(private dialogRef: MatDialogRef<AddChecklistComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService) {}

  ngOnInit() {}

  selectAllContent($event) {
    $event.target.select();
  }

  handleInput(event) {
    this.checklistName = event.target.value;
  }

  confirmDialog() {
    if (this.checklistName !== '') {
      this.dialogRef.close({
        confirmation: true,
        checklistName:
          this.checklistName !== 'Untitled Checklist'
            ? this.checklistName.trim()
            : this.data?.currentChecklistName
            ? this.data?.currentChecklistName
            : this.checklistName.trim(),
      });
    } else {
      this.toastr.error(
        this.data?.isSharedVault
          ? 'Please provide a shared vault name'
          : this.data?.isReport
          ? 'Please provide a report name'
          : this.data?.isWorkspace
          ? 'Please provide a workspace name'
          : 'Please provide a Checklist name'
      );
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  checkIfDisabled() {
    if (this.checklistName.replace(/\s/g, '').length == 0) {
      return true;
    }
  }
}
